import type { PlayerReport } from "../../../api/playerReports";
import { EvidenceLinks } from "./EvidenceLinks";

export function WorkPlan({ data }: { data: PlayerReport }) {
  return (
    <section
      id="trabajo"
      className="report-section"
      aria-labelledby="work-heading"
    >
      <p className="report-eyebrow">03 · Próxima práctica</p>
      <h2 id="work-heading">Qué vale la pena trabajar ahora</h2>
      <p className="report-muted">
        Un foco concreto, el registro que lo respalda y una forma de revisarlo
        con tu entrenador.
      </p>
      <div
        className="report-signal-legend"
        aria-label="Leyenda de los semáforos"
      >
        {[
          ["green", "Sostener"],
          ["amber", "Explorar"],
          ["red", "Priorizar"],
          ["gray", "Construir referencia"],
        ].map(([tone, label]) => (
          <span className={`report-signal-badge signal-${tone}`} key={tone}>
            <span aria-hidden="true" className="report-signal-dot" />
            {label}
          </span>
        ))}
      </div>
      <div className="report-work-list">
        {data.evidence.plan.map((f, i) => (
          <article
            key={f.title}
            className={`report-work-card signal-${f.tone}`}
          >
            <div>
              <span className={`report-signal-badge signal-${f.tone}`}>
                <span className="report-signal-dot" aria-hidden="true" />
                {f.status}
              </span>
              <h3>
                {i + 1}. {f.title}
              </h3>
              <p>{f.summary}</p>
              <p className="report-caption">{f.basis}</p>
              <EvidenceLinks refs={f.evidence} />
              {f.comparison_evidence.length > f.evidence.length && (
                <EvidenceLinks refs={f.comparison_evidence} comparison />
              )}
            </div>
            <div className="report-work-action">
              <p className="report-eyebrow">Qué probar</p>
              <p>{f.action}</p>
              <p className="report-eyebrow">Qué revisar después</p>
              <p>{f.check}</p>
            </div>
          </article>
        ))}
      </div>
      <details className="report-disclosure">
        <summary>Cómo elegimos estos focos y colores</summary>
        <p className="report-caption">{data.evidence.method}</p>
      </details>
    </section>
  );
}
